import { formatMoneyFull } from "@/lib/money"
import type { Price } from "../types"
import Section from "./Section"

// Planned ASP per sales channel from the published plan covering today, then
// the unit cost (left out by the server for viewers who may not see it).
export default function PriceSection({ price, currency }: { price: Price; currency: string }) {
  return (
    <Section title="Price" aside="Planned ASP">
      {price.channels.length === 0 ? (
        <p className="text-sm text-foreground">No published plan covers today.</p>
      ) : (
        <div className="flex flex-col">
          {price.channels.map((c) => (
            <div key={c.channel_id} className="flex items-baseline justify-between gap-3 py-1 text-sm text-foreground">
              <span className="min-w-0 truncate">
                {c.channel_name} <span className="text-xs">· {c.plan_name}</span>
              </span>
              <span className="tabular-nums">{c.asp === null ? "—" : formatMoneyFull(c.asp, currency)}</span>
            </div>
          ))}
        </div>
      )}
      {price.cogs !== undefined && (
        <div className="flex items-baseline justify-between gap-3 border-t border-border pt-2 text-sm text-foreground">
          <span>Unit cost</span>
          <span className="tabular-nums">{price.cogs === null ? "—" : formatMoneyFull(price.cogs, currency)}</span>
        </div>
      )}
    </Section>
  )
}
